import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const PreviousIcon = withSvgIcon(
    <g>
        <path d="M163.8 100.8L15.3 249.3l149.8 149.9 30.7-30.8-97.3-97.3h386.2v-43.5H98.5l96-96z" />
    </g>
);
